const $ = require('jquery');

window.addEventListener('load', function () {
  $('.form-country select').on('change', (event) => {
    const $this = $(event.target);
    const countryId = $this.val();

    $('.form-state').addClass('hidden');
    $('.form-state select').removeAttr('name');
    $(`.form-state[data-country-id=${countryId}]`).removeClass('hidden');
    $(`.form-state[data-country-id=${countryId}] select`).attr(
      'name',
      'state_id'
    );
  });

  $('.form-country select').trigger('change');

  $('.logout').on('click', (event) => {
    event.preventDefault();
    $('#logout-form').trigger('submit');
  });

  $('label').each((index, el) => {
    const $this = $(el);

    // normal inputs, selects
    let $input = $(`#${$this.attr('for')}`);

    // radio buttons
    if ($input.length === 0) {
      $input = $(`input[type=radio][name=${$this.attr('for')}]`).first();
    }

    if ($input.length === 1 && $input.prop('required')) {
      $this.text(`${$this.text()} *`);
    }
  });

  $('input[type=date]').on('change', (event) => {
    const $this = $(event.target);

    if (!$this.attr('name').endsWith('_date')) {
      return;
    }

    const timeInputName = $this.attr('name').replace('_date', '_time');
    const $timeInput = $(`input[name=${timeInputName}]`);

    if ($timeInput.length === 0) {
      return;
    }

    if ($this.val() !== '') {
      $timeInput.val('00:00');
    } else {
      $timeInput.val('');
    }
  });

  $('input[name=signup_deadline_date]').on('change', (event) => {
    $('input[name=start_date]').attr('min', $(event.target).val());
    $('input[name=end_date]').attr('min', $(event.target).val());
  });

  $('input[name=start_date]').on('change', (event) => {
    $('input[name=signup_deadline_date]').attr('max', $(event.target).val());
    $('input[name=end_date]').attr('min', $(event.target).val());
  });

  $('input[name=end_date]').on('change', (event) => {
    $('input[name=start_date]').attr('max', $(event.target).val());
    $('input[name=end_date]').attr('max', $(event.target).val());
  });

  $('form[data-text-after-submit]').on('submit', (event) => {
    const $this = $(event.target);

    $this
      .find('button[type=submit]')
      .text($this.data('text-after-submit'))
      .attr('disabled', 'disabled')
      .prepend('<i class="fas fa-circle-notch fa-spin"></i> ');
  });
});
